import { Component, Vue } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import QueryableInterface from "@/interfaces/QueryableInterface";
import { Broadcaster } from "@/models";
import * as qs from "qs";

export const GET_BROADCASTERS = "get_broadcasters";

@Component
export default class BroadcastersMixin extends Vue {
  getBroadcasters(params: QueryableInterface): Promise<Broadcaster[]> {
    const path = `${API_ENDPOINT}/broadcasters.json`;

    return this.$store.dispatch("http/request", {
      tag: GET_BROADCASTERS,
      url: path,
      method: "GET",
      params,
      paramsSerializer: (params: QueryableInterface) => {
        return qs.stringify(params, { arrayFormat: "brackets" });
      },
    });
  }
}
